/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener
 * crm-screener
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { LeadScreenerLeadInfoState } from './LeadScreenerLeadInfoState';
import {
    LeadScreenerLeadInfoStateFromJSON,
    LeadScreenerLeadInfoStateFromJSONTyped,
    LeadScreenerLeadInfoStateToJSON,
    LeadScreenerLeadInfoStateToJSONTyped,
} from './LeadScreenerLeadInfoState';
import type { FacilitySeats } from './FacilitySeats';
import {
    FacilitySeatsFromJSON,
    FacilitySeatsFromJSONTyped,
    FacilitySeatsToJSON,
    FacilitySeatsToJSONTyped,
} from './FacilitySeats';
import type { FacilityAlternativeName } from './FacilityAlternativeName';
import {
    FacilityAlternativeNameFromJSON,
    FacilityAlternativeNameFromJSONTyped,
    FacilityAlternativeNameToJSON,
    FacilityAlternativeNameToJSONTyped,
} from './FacilityAlternativeName';
import type { FacilitySystemTag } from './FacilitySystemTag';
import {
    FacilitySystemTagFromJSON,
    FacilitySystemTagFromJSONTyped,
    FacilitySystemTagToJSON,
    FacilitySystemTagToJSONTyped,
} from './FacilitySystemTag';
import type { FacilityPhysiciansInner } from './FacilityPhysiciansInner';
import {
    FacilityPhysiciansInnerFromJSON,
    FacilityPhysiciansInnerFromJSONTyped,
    FacilityPhysiciansInnerToJSON,
    FacilityPhysiciansInnerToJSONTyped,
} from './FacilityPhysiciansInner';
import type { FacilityTimezone } from './FacilityTimezone';
import {
    FacilityTimezoneFromJSON,
    FacilityTimezoneFromJSONTyped,
    FacilityTimezoneToJSON,
    FacilityTimezoneToJSONTyped,
} from './FacilityTimezone';
import type { ExternalEhrFacility } from './ExternalEhrFacility';
import {
    ExternalEhrFacilityFromJSON,
    ExternalEhrFacilityFromJSONTyped,
    ExternalEhrFacilityToJSON,
    ExternalEhrFacilityToJSONTyped,
} from './ExternalEhrFacility';
import type { FacilityDefaultPhysician } from './FacilityDefaultPhysician';
import {
    FacilityDefaultPhysicianFromJSON,
    FacilityDefaultPhysicianFromJSONTyped,
    FacilityDefaultPhysicianToJSON,
    FacilityDefaultPhysicianToJSONTyped,
} from './FacilityDefaultPhysician';

/**
 * 
 * @export
 * @interface Facility
 */
export interface Facility {
    /**
     * 
     */
    name: string;
    /**
     * 
     */
    id: string;
    /**
     * 
     */
    facility_type?: FacilityFacilityTypeEnum;
    /**
     * 
     */
    email?: string;
    /**
     * 
     */
    primary_phone?: string;
    /**
     * 
     */
    state_id?: string;
    /**
     * 
     */
    time_zone_id?: string;
    /**
     * 
     */
    address?: string;
    /**
     * 
     */
    town?: string;
    /**
     * 
     */
    zip_code?: string;
    /**
     * National Provider Identifier (NPI) - a 10-digit numeric ID used to identify Medical Facilities and Practitioners.
     */
    temporary_npi?: string;
    /**
     * 
     */
    fax_number?: string;
    /**
     * 
     */
    tax_id?: string;
    /**
     * 
     */
    medicare_location_type?: string;
    /**
     * 
     */
    wage_index_cbsa_or_state_code?: string;
    /**
     * National Provider Identifier (NPI) - a 10-digit numeric ID used to identify Medical Facilities and Practitioners.
     */
    npi?: string;
    /**
     * 
     */
    createdAt?: string;
    /**
     * 
     */
    updatedAt?: string;
    /**
     * 
     */
    deletedAt?: string;
    /**
     * 
     */
    timezone?: FacilityTimezone;
    /**
     * 
     */
    state?: LeadScreenerLeadInfoState;
    /**
     * 
     */
    seats?: FacilitySeats;
    /**
     * 
     */
    resident_groups?: Array<object>;
    /**
     * 
     */
    alternative_names?: Array<FacilityAlternativeName>;
    /**
     * 
     */
    physicians?: Array<FacilityPhysiciansInner>;
    /**
     * 
     */
    default_physician?: FacilityDefaultPhysician | null;
    /**
     * 
     */
    screener_no_analysis_facility?: boolean;
    /**
     * 
     */
    has_fax_integration?: boolean;
    /**
     * 
     */
    external_ehr_facility?: ExternalEhrFacility;
    /**
     * Server-derived tags computed from facility data (e.g. US state, facility type).
     */
    system_tags?: Array<FacilitySystemTag>;
}


/**
 * @export
 */
export const FacilityFacilityTypeEnum = {
    SkilledNursing: 'SKILLED_NURSING',
    CriticalCare: 'CRITICAL_CARE',
    HomeHealth: 'HOME_HEALTH',
    AssistedLiving: 'ASSISTED_LIVING',
    LongTermCareHospital: 'LONG_TERM_CARE_HOSPITAL',
    Hospice: 'HOSPICE',
    DialysisCenter: 'DIALYSIS_CENTER',
    Hospital: 'HOSPITAL',
} as const;
export type FacilityFacilityTypeEnum = typeof FacilityFacilityTypeEnum[keyof typeof FacilityFacilityTypeEnum];


/**
 * Check if a given object implements the Facility interface.
 */
export function instanceOfFacility(value: object): value is Facility {
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('id' in value) || value['id'] === undefined) return false;
    return true;
}

export function FacilityFromJSON(json: any): Facility {
    return FacilityFromJSONTyped(json, false);
}

export function FacilityFromJSONTyped(json: any, ignoreDiscriminator: boolean): Facility {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'],
        'id': json['id'],
        'facility_type': json['facility_type'] == null ? undefined : json['facility_type'],
        'email': json['email'] == null ? undefined : json['email'],
        'primary_phone': json['primary_phone'] == null ? undefined : json['primary_phone'],
        'state_id': json['state_id'] == null ? undefined : json['state_id'],
        'time_zone_id': json['time_zone_id'] == null ? undefined : json['time_zone_id'],
        'address': json['address'] == null ? undefined : json['address'],
        'town': json['town'] == null ? undefined : json['town'],
        'zip_code': json['zip_code'] == null ? undefined : json['zip_code'],
        'temporary_npi': json['temporary_npi'] == null ? undefined : json['temporary_npi'],
        'fax_number': json['fax_number'] == null ? undefined : json['fax_number'],
        'tax_id': json['tax_id'] == null ? undefined : json['tax_id'],
        'medicare_location_type': json['medicare_location_type'] == null ? undefined : json['medicare_location_type'],
        'wage_index_cbsa_or_state_code': json['wage_index_cbsa_or_state_code'] == null ? undefined : json['wage_index_cbsa_or_state_code'],
        'npi': json['npi'] == null ? undefined : json['npi'],
        'createdAt': json['createdAt'] == null ? undefined : json['createdAt'],
        'updatedAt': json['updatedAt'] == null ? undefined : json['updatedAt'],
        'deletedAt': json['deletedAt'] == null ? undefined : json['deletedAt'],
        'timezone': json['timezone'] == null ? undefined : FacilityTimezoneFromJSON(json['timezone']),
        'state': json['state'] == null ? undefined : LeadScreenerLeadInfoStateFromJSON(json['state']),
        'seats': json['seats'] == null ? undefined : FacilitySeatsFromJSON(json['seats']),
        'resident_groups': json['resident_groups'] == null ? undefined : json['resident_groups'],
        'alternative_names': json['alternative_names'] == null ? undefined : ((json['alternative_names'] as Array<any>).map(FacilityAlternativeNameFromJSON)),
        'physicians': json['physicians'] == null ? undefined : ((json['physicians'] as Array<any>).map(FacilityPhysiciansInnerFromJSON)),
        'default_physician': json['default_physician'] === undefined ? undefined : json['default_physician'] === null ? null : FacilityDefaultPhysicianFromJSON(json['default_physician']),
        'screener_no_analysis_facility': json['screener_no_analysis_facility'] == null ? undefined : json['screener_no_analysis_facility'],
        'has_fax_integration': json['has_fax_integration'] == null ? undefined : json['has_fax_integration'],
        'external_ehr_facility': json['external_ehr_facility'] == null ? undefined : ExternalEhrFacilityFromJSON(json['external_ehr_facility']),
        'system_tags': json['system_tags'] == null ? undefined : ((json['system_tags'] as Array<any>).map(FacilitySystemTagFromJSON)),
    };
}

export function FacilityToJSON(json: any): Facility {
    return FacilityToJSONTyped(json, false);
}

export function FacilityToJSONTyped(value?: Facility | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'id': value['id'],
        'facility_type': value['facility_type'],
        'email': value['email'],
        'primary_phone': value['primary_phone'],
        'state_id': value['state_id'],
        'time_zone_id': value['time_zone_id'],
        'address': value['address'],
        'town': value['town'],
        'zip_code': value['zip_code'],
        'temporary_npi': value['temporary_npi'],
        'fax_number': value['fax_number'],
        'tax_id': value['tax_id'],
        'medicare_location_type': value['medicare_location_type'],
        'wage_index_cbsa_or_state_code': value['wage_index_cbsa_or_state_code'],
        'npi': value['npi'],
        'createdAt': value['createdAt'],
        'updatedAt': value['updatedAt'],
        'deletedAt': value['deletedAt'],
        'timezone': FacilityTimezoneToJSON(value['timezone']),
        'state': LeadScreenerLeadInfoStateToJSON(value['state']),
        'seats': FacilitySeatsToJSON(value['seats']),
        'resident_groups': value['resident_groups'],
        'alternative_names': value['alternative_names'] == null ? undefined : ((value['alternative_names'] as Array<any>).map(FacilityAlternativeNameToJSON)),
        'physicians': value['physicians'] == null ? undefined : ((value['physicians'] as Array<any>).map(FacilityPhysiciansInnerToJSON)),
        'default_physician': FacilityDefaultPhysicianToJSON(value['default_physician']),
        'screener_no_analysis_facility': value['screener_no_analysis_facility'],
        'has_fax_integration': value['has_fax_integration'],
        'external_ehr_facility': ExternalEhrFacilityToJSON(value['external_ehr_facility']),
        'system_tags': value['system_tags'] == null ? undefined : ((value['system_tags'] as Array<any>).map(FacilitySystemTagToJSON)),
    };
}

